import { Component } from '@angular/core';
import { ApiService } from '../../services/API/api.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-failed-order',
  templateUrl: './failed-order.component.html',
  styleUrl: './failed-order.component.scss'
})
export class FailedOrderComponent {
  orderId: string = '';
  constructor(private apiService: ApiService,private route: ActivatedRoute) {
    this.route.params.subscribe(params => {
      if(params.id){
        this.orderId = params.id;
      }
    });
  }

  ngOnInit(): void {
    localStorage.removeItem('couponApplied')
    localStorage.removeItem('couponValue')
    localStorage.removeItem('couponCode')
    localStorage.removeItem('couponType')
    localStorage.removeItem('couponId')
    this.updatePaymentState()
  }

  private updatePaymentState(): void {
    this.apiService.updatePaymentState({ payment_state: 'failed' }, this.orderId).subscribe({});
  }
}
